__turbopack_context__.v({
  "alignment": "_eoCmG_alignment",
  "container": "_eoCmG_container",
  "freeze": "_eoCmG_freeze",
  "shadow": "_eoCmG_shadow",
});
